import script from "./VVVClaimSubmission.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVClaimSubmission.vue?vue&type=script&setup=true&lang=js"

import "./VVVClaimSubmission.vue?vue&type=style&index=0&id=460b44cc&scoped=true&lang=css"
import "./VVVClaimSubmission.vue?vue&type=style&index=1&id=460b44cc&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460b44cc"]])

export default __exports__